import React from 'react';
import { createRoot } from 'react-dom/client';
import AboutPage from '../components/tournaments/AboutPage.jsx';
import TournamentsLayout from '../components/tournaments/TournamentsLayout.jsx';

const root = createRoot(document.getElementById('root'));
root.render(
  <TournamentsLayout active="about">
    <AboutPage />
  </TournamentsLayout>
);
